import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CourseCard from "./CourseCard";
import ContentCard from "./ContentCard";
import LeftSidebar from "../../components/LeftSideBar";
import "./Courses.css";
import SyntaxHighlighter from "react-syntax-highlighter";
import { irBlack } from "react-syntax-highlighter/dist/esm/styles/hljs";

import fetchProtectedData from "../auth/ProtectDataHeader";
import withTokenRefresh from "../auth/RefreshToken";
import PaymentModal from "../payment/PaymentModal";
import SubscribeInfoModal from "../payment/SubscribeInfoModal";
import SubscribeInfoGenerate from "../payment/SubscribeInfoGenerate";
import MobileModal from "./MobileModal";

import { ReactComponent as SqlIcon  } from "../../icons/sql.svg";
import { ReactComponent as PyIcon   } from "../../icons/python.svg";
import { ReactComponent as JSIcon   } from "../../icons/react.svg";
import { ReactComponent as DIcon    } from "../../icons/data.svg";
import { ReactComponent as ALIcon   } from "../../icons/alghos.svg";
import { ReactComponent as GOIcon   } from "../../icons/goolang.svg";
import { ReactComponent as SearchIcon } from "../../icons/search.svg";  

import TasksOverTime from "../progress/TasksOverTime";
import TasksCompleted   from "../progress/TasksCompleted";


const Courses = () => {
  const navigate = useNavigate();
  const [dailyContent, setDailyContent] = useState(null);
  const [user_id, setUserId] = useState(null);
  const [courses, setCourses] = useState(null);
  const [courseGenerationStatus, setCourseGenerationStatus] = useState(null);
  const [courseGenerationError, setCourseGenerationError] = useState(null);

  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [showInfoGenerateModal, setShowInfoGenerateModal] = useState(false);

  const [progressData, setProgressData] = useState(null);

  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollStart, setScrollStart] = useState(0);

  const ICON_MAP = {
    "Базовый курс по SQL":       SqlIcon,
    "Базовый курс по Python":    PyIcon,
    "Основы JavaScript, React":  JSIcon,
    "Собеседование по алгоритмам: Python": ALIcon,
    "Основы Дата аналитики": DIcon, 
    "Базовый курс по Golang": GOIcon,
  };
  
  const [searchTerm, setSearchTerm] = React.useState("");

  const visibleCourses = (courses || []).filter(c =>
    c.course_name.toLowerCase().includes(searchTerm.trim().toLowerCase())
  );

  const [isHeaderVisible, setIsHeaderVisible] = useState(true);
  const lastScrollY = useRef(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollStart(scrollRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2; 
    scrollRef.current.scrollLeft = scrollStart - walk;
  };

  const endDrag = () => {
    setIsDragging(false);
  };

  const openPaymentModal = () => setShowPaymentModal(true);
  const closePaymentModal = () => setShowPaymentModal(false);

  const openInfoModal = (text) => {
    if (text) {
      setInfoText(text);
    } else {
      setInfoText("");
    }
    setShowInfoModal(true);
  };


  const closeInfoModal = () => setShowInfoModal(false);

  const [infoText, setInfoText] = useState("");

  const openInfoGenerateModal = () => setShowInfoGenerateModal(true);
  const closeInfoGenerateModal = () => setShowInfoGenerateModal(false);

  const [subscriptionType, setSubscriptionType] = useState("expired");
  const [subscriptionEndDate, setSubscriptionEndDate] = useState(null);

  const [width, setWidth] = useState(window.innerWidth);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const isMobile = width <= 768;

  const handleProtectedAction = (action, is_open_for_everyone) => {
    if (subscriptionType === "expired") {
      openInfoModal("Для просмотра курса нужна подписка");
    } else if (is_open_for_everyone === false) {
      openInfoModal("Для просмотра курса нужна подписка");
    } else {
      action();
    }
  };

  const [showFormModal, setShowFormModal] = useState(false);
  const [showReadyModal, setShowReadyModal] = useState(false);

  const handleOpenForm = () => {
    setShowFormModal(true);
  };

  const handleCloseForm = () => {
    setShowFormModal(false);
  };

  const handleGenerate = async () => {
    setShowFormModal(false);
    setShowReadyModal(true);

    try {
      const response = await fetch("/api/course/generate", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          want_to_educate_theme: courseName,
          who_i_am: "программист",
          my_level: knowledge,
          course_description: extraInfo,
          dont_want_to_educate: dontEducate,
          overall_level: 1,
          user_id: user_id,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      if (data.ok === false) {
        setCourseGenerationStatus("already_generated");
        setCourseGenerationError(data.error);
      } else {
        setCourseGenerationStatus("generated");
      }
    } catch (error) {
      console.error("Error generating course:", error);
    }
  };

  const handleGenerateClick = () => {
    setShowFormModal(true);
  };

  const handleCloseReady = async () => {
    setShowReadyModal(false);
    setCourseGenerationStatus(null);
    try {
      await fetchCoursesData();
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const [courseName, setCourseName] = useState("");
  const [knowledge, setKnowledge] = useState("");
  const [extraInfo, setExtraInfo] = useState("");
  const [dontEducate, setDontEducate] = useState("");

  const EXAMPLE_COURSE_NAME = "Pandas";
  const EXAMPLE_KNOWLEDGE = `Я хорошо знаю Python, программирую на нем 2 года,
2 недели изучал numpy, про Pandas знаю очень мало, только то, что
его используют для анализа данных`;
  const EXAMPLE_EXTRA_INFO = `Хочу узнать, где pandas работает быстро, а где медленно.
Хочу разобраться с самыми основными методами pandas, как они работают под капотом.`;
  const EXAMPLE_DONT_EDUCATE = `Не хочу разбираться, как устроена визуализация в pandas`;

  const handleExampleMouseEnter = () => {
    if (!courseName.trim()) {
      setCourseName(EXAMPLE_COURSE_NAME);
    }
    if (!knowledge.trim()) {
      setKnowledge(EXAMPLE_KNOWLEDGE);
    }
    if (!extraInfo.trim()) {
      setExtraInfo(EXAMPLE_EXTRA_INFO);
    }
    if (!dontEducate.trim()) {
      setDontEducate(EXAMPLE_DONT_EDUCATE);
    }
  };

  const handleExampleMouseLeave = () => {
    if (courseName.trim() === EXAMPLE_COURSE_NAME) {
      setCourseName("");
    }
    if (knowledge.trim() === EXAMPLE_KNOWLEDGE) {
      setKnowledge("");
    }
    if (extraInfo.trim() === EXAMPLE_EXTRA_INFO) {
      setExtraInfo("");
    }
    if (dontEducate.trim() === EXAMPLE_DONT_EDUCATE) {
      setDontEducate("");
    }
  };

  const fetchCoursesData = async () => {
    const protectedData = await withTokenRefresh(fetchProtectedData);
    if (!protectedData) {
      navigate("/registration");
      return;
    }
    const response_courses = await fetch(
      `/api/course/available_courses/${protectedData}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      }
    );
    if (!response_courses.ok) {
      throw new Error(`HTTP error! status: ${response_courses.status}`);
    }
    const data_courses = await response_courses.json();
    data_courses.courses.splice(1, 0, {
      course_name: "Сгенерируй свой курс",
      front_name: "Сгенерируй свой курс",
      progress: "",
      link: "/create-course",
      is_open_for_everyone: true,
    });

    data_courses.courses = data_courses.courses.map(course => ({
      ...course,
      // course_name: !course.is_open_for_everyone 
      //   ? `🔒 ${course.course_name}`
      //   : course.course_name,
      front_name: !course.is_open_for_everyone 
        ? `🔒 ${course.front_name}`
        : course.front_name
    }));
    
    setCourses(data_courses.courses);
  };

  const copyCodeToClipboard = () => {
    if (!dailyContent) return;
    navigator.clipboard
      .writeText(dailyContent.technical_response)
      .then(() => console("Код скопирован в буфер обмена!"))
      .catch((error) => console.error("Copy failed", error));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const protectedData = await withTokenRefresh(fetchProtectedData);
        if (!protectedData) {
          navigate("/registration");
          return;
        }
        setUserId(protectedData);

        const SUB_ENDPOINT = `/api/subscription/?user_id=${protectedData}`;
        const subscriptionResponse = await fetch(SUB_ENDPOINT, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        if (!subscriptionResponse.ok) {
          throw new Error(`HTTP error! status: ${subscriptionResponse.status}`);
        }

        const subscriptionData = await subscriptionResponse.json();
        setSubscriptionType(subscriptionData.status);

        const subscriptionEndDate = new Date(
          subscriptionData.current_period_end
        );
        setSubscriptionEndDate(
          subscriptionEndDate.toLocaleDateString().replace(/\//g, "-")
        );

        fetchCoursesData();
      } catch (err) {
        navigate("/registration");
      }
    };
    fetchData();
  }, [navigate]);

  useEffect(() => {
    fetchCoursesData();
    const intervalId = setInterval(fetchCoursesData, 60000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchDailyContent = async () => {
      try {
        const response = await fetch("api/daily_content/content", {
          method: "POST",
          headers: { Accept: "application/json" },
        });
        if (!response.ok) {
          throw new Error("Failed to fetch daily content");
        }
        const data = await response.json();
        setDailyContent(data);
      } catch (error) {
        console.error("Error fetching daily content:", error);
      }
    };

    fetchDailyContent();
  }, [navigate]);

  useEffect(() => {
    const fetchProgressData = async () => {
      try {

        const protectedData = await withTokenRefresh(fetchProtectedData);
        if (!protectedData) {
          navigate("/registration");
          return;
        }

        const API_ENDPOINT = `api/users/${protectedData}/progress`;

        const response = await fetch(API_ENDPOINT, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const progressData = await response.json();
        setProgressData(progressData);
      } catch (err) {
        console.log("Error fetching progress data");
      }
    };
    fetchProgressData();
  }, [navigate]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      if (currentScrollY > lastScrollY.current) {
        // Scrolling down
        setIsHeaderVisible(false);
      } else {
        // Scrolling up
        setIsHeaderVisible(true);
      }
      
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (!progressData) {
    return <p>Загрузка данных…</p>;
  }

  const {
    current_streak,
    max_streak,
    streak_improvement_percentage,
    total_tasks_solved,
    total_tasks_solved_percentage,
    daily_tasks_solved_last_7_days,
    tasks_solved_last_7_days_improvement_percentage,
    tasks_solved_by_topic,
    total_theories_solved,
    total_theories_solved_percentage,
    theories_solved_by_topic,
  } = progressData || {};

  const tasksSolvedLast7Days = daily_tasks_solved_last_7_days;


  const content = {
    title: "История успеха",
    text: dailyContent?.motivation_response || "Загрузка...",
  };

  const handleGenerateCardClick = () => {
    console.error("my status: ", subscriptionType)
    if (subscriptionType !== "active" && subscriptionType !== 'trial') {
      openInfoGenerateModal();
    } else {
      handleGenerateClick();
    }
  };

  return (
    <div className="course-container">
      {showPaymentModal && (
        <PaymentModal
          onClose={closePaymentModal}
          subscriptionType={subscriptionType}
          subscriptionEndDate={subscriptionEndDate}
          user_id={user_id}
        />
      )}
      {showInfoModal && <SubscribeInfoModal onClose={closeInfoModal} text={infoText || undefined}/>}
      {showInfoGenerateModal && (
        <SubscribeInfoGenerate onClose={closeInfoGenerateModal} />
      )}
      <LeftSidebar
      />
      <div className="courses-main-content">
        <div className={`courses-header ${!isHeaderVisible ? 'hidden' : ''}`}>
          <div className="courses-header-text">
            <h1>Курсы для тебя</h1>
            <p>Здесь собраны все курсы с задачами</p>
          </div>

          <div className="courses-header-search">
            <input
              type="text"
              placeholder="Поиск"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <button
              className="search-button"
            >
              <SearchIcon />
            </button>
          </div>
        </div>
        <section className="course-grid">
          {courses ? (
            <>
              {visibleCourses.slice(0, 1).map((course) => {
                const isGenerate = course.course_name === "Сгенерируй свой курс";
                const Icon       = !isGenerate && ICON_MAP[course.course_name];

                return (
                  <CourseCard
                    key={course.id}
                    course={course}
                    Icon={Icon}
                    status={course.g_status}
                    onClick={
                      isGenerate
                        ? handleGenerateCardClick
                        : () =>
                            handleProtectedAction(() =>
                              navigate(`/topics?course=${course.course_name}`),
                              course.is_open_for_everyone
                            )
                    }
                    extraClass={[
                      isGenerate ? "highlight" : "",
                      "tall"                    
                    ].join(" ")}
                    is_open_for_everyone={course.is_open_for_everyone}
                  />
                );
              })}

              {visibleCourses.slice(1, 2).map((course) => {
                const isGenerate = course.course_name === "Сгенерируй свой курс";
                const Icon       = !isGenerate && ICON_MAP[course.course_name];

                return (
                  <CourseCard
                    key={course.id}
                    course={course}
                    Icon={Icon}
                    status={course.g_status}
                    onClick={
                      isGenerate
                        ? handleGenerateCardClick
                        : () =>
                            handleProtectedAction(() =>
                              navigate(`/topics?course=${course.course_name}`),
                              course.is_open_for_everyone
                            )
                    }
                    extraClass={isGenerate ? "highlight" : ""}
                    is_open_for_everyone={course.is_open_for_everyone}
                  />
                );
              })}

              {/* Maybe return it */}
              {/* {!searchTerm && (
                      <div key="stats" className="stats-card tall">
                        <TasksOverTime
                          dailyTasksSolvedLast7Days={tasksSolvedLast7Days}
                          percentageChange={tasks_solved_last_7_days_improvement_percentage}
                        />
                      </div>
              )} */}

              {!searchTerm && (
                      <div key="completed" className="completed-card">
                        <TasksCompleted
                          tasksCompleted={total_tasks_solved}
                          completionPercentage={total_tasks_solved_percentage}
                        />
                      </div>
              )}

              {visibleCourses.slice(2).map((course) => {
                const isGenerate = course.course_name === "Сгенерируй свой курс";
                const Icon       = !isGenerate && ICON_MAP[course.course_name];

                return (
                  <CourseCard
                    key={course.id}
                    course={course}
                    Icon={Icon}
                    status={course.g_status}
                    onClick={
                      isGenerate
                        ? handleGenerateCardClick
                        : () =>
                            handleProtectedAction(() =>
                              navigate(`/topics?course=${course.course_name}`),
                              course.is_open_for_everyone
                            )
                    }
                    extraClass={isGenerate ? "highlight" : ""}
                    is_open_for_everyone={course.is_open_for_everyone}
                  />
                );
              })}
            </>
          ) : (
            <p>Загрузка...</p>
          )}
        </section>
        {showFormModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="close-button" onClick={handleCloseForm}>
                ✕
              </button>
              <h2>Напиши что хочешь изучать</h2>

              <div className="modal-form">
                <input
                  type="text"
                  placeholder="Название курса"
                  value={courseName}
                  onChange={(e) => setCourseName(e.target.value)}
                  className="modal-input"
                />
                <textarea
                  placeholder={`Оцени свои знания
Пиши в свободной форме все, что посчитаешь нужным`}
                  value={knowledge}
                  onChange={(e) => setKnowledge(e.target.value)}
                  className="modal-textarea"
                />
                <textarea
                  placeholder={`Дополнительная информация по курсу
• Какие темы обязательно должны быть
• Пиши в свободной форме всё, что посчитаешь нужным`}
                  value={extraInfo}
                  onChange={(e) => setExtraInfo(e.target.value)}
                  className="modal-textarea"
                />
                <textarea
                  placeholder={`Напиши что не хочешь изучать в свободной форме`}
                  value={dontEducate}
                  onChange={(e) => setDontEducate(e.target.value)}
                  className="modal-textarea"
                />
              </div>

              <div className="button-group">
                <button
                  className="btn-secondary"
                  onMouseEnter={handleExampleMouseEnter}
                  onMouseLeave={handleExampleMouseLeave}
                >
                  Пример
                </button>
                <button className="btn-primary" onClick={handleGenerate}>
                  Сгенерировать
                </button>
              </div>
            </div>
          </div>
        )}
        {showReadyModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="close-button" onClick={handleCloseReady}>
                ✕
              </button>
              {courseGenerationStatus === "already_generated" ? (
                <h2 style={{ marginBottom: "1rem" }}>
                  {courseGenerationError}
                </h2>
              ) : (
                <>
                  <h2 style={{ marginBottom: "1rem" }}>
                    Скоро твой курс будет готов
                  </h2>
                  <p style={{ fontSize: "1.1rem", color: "#777" }}>
                    Ищи его в списке курсов.
                    <br />
                    Темы будут появляться постепенно.
                  </p>
                </>
              )}
            </div>
          </div>
        )}
        {/* <section className="course-section">
          <div className="course-grid">
            <ContentCard content={content} />

            <div className="content-code-wrapper">
              <div className="content-code-header">
                <span className="language-badge">python</span>
                <button className="copy-button" onClick={copyCodeToClipboard}>
                  Скопировать
                </button>
              </div>
              <div className="content-code">
                <SyntaxHighlighter
                  language="python"
                  style={irBlack}
                  wrapLongLines
                  customStyle={{ padding: "1px" }}
                >
                  {dailyContent?.technical_response || "# Загрузка…"}
                </SyntaxHighlighter>
              </div>
            </div>
          </div>
        </section> */}
      </div>
    </div>
  );
};

export default Courses;
